import { Button, Divider } from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { E2FAMethod, E2FAMethodTab, ETranslationNs } from 'src/types'
import { useStyles } from '../styles'

interface IProps {
  setSubTab: (tab: E2FAMethodTab) => void
  subTab: E2FAMethodTab
  method: E2FAMethod | null
}

export const MethodButtons = ({ method, subTab, setSubTab }: IProps) => {
  const classes = useStyles()

  if (!method || subTab !== E2FAMethodTab.Home) {
    return null
  }

  const handleDisable = () => {
    setSubTab(E2FAMethodTab.Disable)
  }

  const handleSwitch = () => {
    setSubTab(E2FAMethodTab.Switch)
  }

  return (
    <div>
      <div className={classes.section}>
        <h3 className={classes.sectionTitle} style={{ marginBottom: 0 }}>
          <HelperWrapper t="2fa-disable-title" ns={ETranslationNs.UserProfile} />
        </h3>
        <Button size="medium" className={classes.codeButton} onClick={handleDisable}>
          <HelperWrapper t="disable-button-text" ns={ETranslationNs.UserProfile} />
        </Button>
      </div>
      <Divider className={classes.divider} />
      <div className={classes.section}>
        <h3 className={classes.sectionTitle} style={{ marginBottom: 0 }}>
          <HelperWrapper t="2fa-email-change-title" ns={ETranslationNs.UserProfile} />
        </h3>
        <Button size="medium" className={classes.codeButton} onClick={handleSwitch}>
          <HelperWrapper t="2fa-change-submit" ns={ETranslationNs.UserProfile} />
        </Button>
      </div>
    </div>
  )
}
